import { Component } from '@angular/core';
import { nav_path } from '../../../../app-routing.module';
import { MenuItem } from '../../../../shared/interfaces/menu-item';
import { MenuService } from '../../../../shared/services/menu.service';

@Component({
  selector: 'anon-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent {
  public title: string = 'Dashboard';
  nav_path = nav_path;
  adminPages: MenuItem[];

  constructor(public readonly menuService: MenuService) {
    this.adminPages = menuService.adminMenu.filter(menuItem => menuItem.name != this.title);
  }
}
